import axios from 'axios'
import { DEFAULT_LANGUAGE } from '../../constants'

export const http = axios.create()

http.interceptors.request.use(config => {
  const lang = localStorage.getItem('preferredLanguage') ?? DEFAULT_LANGUAGE
  config.headers['Accept-Language'] = lang
  return config
})

export default http
